import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const loginWithApple = (
    response,
    countryName,
    countryCd,
    countryCurrCd,
    countryTelCd,
    location,
    latitude,
    longitude
) => {
    return new Promise((resolve, reject) => {
        const data = {
            email: response.email,
            userfname: response.name?.firstName || response.email,
            userlname: response.name?.lastName || '',
            gender: "",
            accountType: "General",
            activeInd: "Y",
            profilePic: "", // Assuming profilePicUrl is part of the response
            countryName,
            countryCd,
            countryCurrCd,
            countryTelCd,
            location: location ?? countryName,
            userLat: latitude,
            userLng: longitude,
            captchaToken: ""
        };

        axios({
        method: "POST",
        url: api_url + "/public/LoginAppleUser",
        data: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            console.error(error);
            reject(error);
        });
    });
};